import { render, staticRenderFns } from "./EmployeeChangepassword.vue?vue&type=template&id=7ff1fc7d&"
import script from "./EmployeeChangepassword.vue?vue&type=script&lang=js&"
export * from "./EmployeeChangepassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports